var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bubble d-none d-md-block"},[_c('strong',{staticClass:"mb-2"},[_vm._v("Lo sapevi che...")]),_c('br'),_vm._v(" "+_vm._s(_vm.funfact.fact)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }